import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
import "./../../bindings/bao-tree";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchInfo(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearch/ExpandedInfo";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.Categories = ko.observableArray([]);
    self.Category = ko.observable("");
    self.CategoryFullName = ko.observable("");
    self.CategoryStructureID = ko.observable("");
    self.CategoryStructureID.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.StartDateHtml = ko.observable();
    self.StartDateHtml.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.EndDateHtml = ko.observable();
    self.EndDateHtml.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedAreas = ko.observableArray([]);
    self.AreaName = ko.observable();
    self.AreaId = ko.observable();
    self.AreaId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedAreaEquipments = ko.observableArray([]);
    self.EquipmentName = ko.observable();
    self.AreaEquipmentId = ko.observable();
    self.AreaEquipmentId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedDevice3s = ko.observableArray([]);
    self.Device3Name = ko.observable();
    self.Device3Id = ko.observable();
    self.Device3Id.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedDevice4s = ko.observableArray([]);
    self.Device4Name = ko.observable();
    self.Device4Id = ko.observable();
    self.Device4Id.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedInfoLevels = ko.observableArray([]);
    self.InfoLevelName = ko.observable();
    self.InfoLevelId = ko.observable();
    self.InfoLevelId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShiftbookIds = ko.observableArray([]);
    self.ShiftbookNames = ko.observable("");
    self.ShiftbookIds.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedShiftOrgUnits = ko.observableArray([]);
    self.ShiftOrgUnitName = ko.observable();
    self.ShiftOrgUnitId = ko.observable();
    self.ShiftOrgUnitId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedInfoStates = ko.observableArray([]);
    self.InfoStateName = ko.observable();
    self.InfoStateId = ko.observable();
    self.InfoStateId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.InfoCreatedBy = ko.observable("");
    self.InfoCreatedBy.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.UpdateDateHtml = ko.observable();
    self.UpdateDateHtml.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });

    self.SapNumber = ko.observable();
    self.SapNumber.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });

    self.GetCustomFilter = function () {
        if (self.AreaId() == null
            && self.AreaEquipmentId() == null
            && self.Device3Id() == null
            && self.Device4Id() == null
            && self.CategoryStructureID() == null
            && self.InfoLevelId() == null
            && self.InfoStateId() == null
            && self.ShiftOrgUnitId() == null
            && Bao.Utils.String.IsNullOrWhitespace(self.StartDateHtml())
            && Bao.Utils.String.IsNullOrWhitespace(self.EndDateHtml())
            && self.InfoCreatedBy() == null
            && self.UpdateDateHtml() == null) {
            return null;
        }
        else {
            return {
                StartDate: JSON.stringify(self.StartDateHtml()),
                EndDate: JSON.stringify(self.EndDateHtml()),
                AreaId: JSON.stringify(self.AreaId()),
                AreaEquipmentId: JSON.stringify(self.AreaEquipmentId()),
                Device3Id: JSON.stringify(self.Device3Id()),
                Device4Id: JSON.stringify(self.Device4Id()),
                CategoryIdsViaBaoSearcher: JSON.stringify(self.CategoryStructureID()),
                ShiftOrgUnitId: JSON.stringify(self.ShiftOrgUnitId()),
                InfoLevelId: JSON.stringify(self.InfoLevelId()),
                InfoStateId: JSON.stringify(self.InfoStateId()),
                ShiftbookIds: JSON.stringify(self.ShiftbookIds()),
                CreatedBy: JSON.stringify(Bao.Utils.String.IsNullOrWhitespace(self.InfoCreatedBy()) ? self.InfoCreatedBy(null) : self.InfoCreatedBy()),
                UpdateDate: JSON.stringify(self.UpdateDateHtml()),
                SapNumber: JSON.stringify(self.SapNumber())
            };
        }
    };
    self.init = function () {
        return $.when(self.LoadHtml());
    };
}
export default ExpandedSearchInfo;